/*
  ADA / WCAG 2.2 AA — accessibility patches for the Process Wholesale app's sign-up
  form (<pw-signup-form>). The form's markup is rendered entirely by that app, not by
  this theme, so it can't be edited directly in Liquid; this script only adds missing
  attributes at runtime and never removes or renames anything the app's own script
  depends on.

  Fixes (WCAG 1.3.5 Identify Input Purpose, 3.3.1 Error Identification,
  3.3.2 Labels or Instructions, 4.1.2 Name, Role, Value):
    - autocomplete tokens on business-address fields that are missing one
    - the two "State" fields (dropdown + manual entry, only one ever visible)
      get a visually-hidden word telling them apart
    - the app's error banner gets role="alert" and receives focus when it appears
*/
(function () {
  'use strict';

  var AUTOCOMPLETE_BY_ID_SUFFIX = [
    [/BusinessName$/, 'organization'],
    [/phoneNumber$/, 'tel'],
    [/website$/i, 'url'],
    [/_address1$/, 'address-line1'],
    [/_address2$/, 'address-line2'],
    [/_city$/, 'address-level2'],
    [/_zip_code$/, 'postal-code'],
    [/_country$/, 'country-name']
  ];

  function patchAutocomplete(form) {
    Array.prototype.forEach.call(form.querySelectorAll('input:not([autocomplete]), select:not([autocomplete])'), function (el) {
      for (var i = 0; i < AUTOCOMPLETE_BY_ID_SUFFIX.length; i++) {
        if (AUTOCOMPLETE_BY_ID_SUFFIX[i][0].test(el.id)) {
          el.setAttribute('autocomplete', AUTOCOMPLETE_BY_ID_SUFFIX[i][1]);
          return;
        }
      }
    });
  }

  // Two "State" fields exist (a <select> and a manual <input>) and the app shows
  // exactly one at a time by toggling display:none + disabled on the other, but both
  // carry a plain "State" label. Tell them apart for anyone using a screen reader's
  // form/label list, without touching the ids the app's own script looks up.
  function disambiguateStateLabels(form) {
    Array.prototype.forEach.call(form.querySelectorAll('label'), function (label) {
      if (label.dataset.adaStateLabelled) return;
      if (!/^\s*State\s*$/.test(label.textContent)) return;
      var field = document.getElementById(label.getAttribute('for'));
      if (!field) return;
      var hint = field.tagName === 'SELECT' ? ' (choose from list)' : ' (type manually)';
      var span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = hint;
      label.appendChild(span);
      label.dataset.adaStateLabelled = '1';
    });
  }

  function watchErrors(form) {
    var errorBox = form.querySelector('.js-pw-signup-alert-message, #field-box');
    if (!errorBox) return;
    var announce = function () {
      var alertEl = form.querySelector('.js-pw-signup-alert-message');
      if (!alertEl || !alertEl.textContent.trim()) return;
      if (!alertEl.hasAttribute('role')) alertEl.setAttribute('role', 'alert');
      if (!alertEl.hasAttribute('tabindex')) alertEl.setAttribute('tabindex', '-1');
      alertEl.focus();
    };
    new MutationObserver(announce).observe(form, { childList: true, subtree: true, characterData: true });
    announce();
  }

  function patch(form) {
    if (form.dataset.adaWholesalePatched) return;
    form.dataset.adaWholesalePatched = '1';
    patchAutocomplete(form);
    disambiguateStateLabels(form);
    watchErrors(form);
    // Country/state selection swaps fields dynamically; re-run the light-touch passes.
    new MutationObserver(function () {
      patchAutocomplete(form);
      disambiguateStateLabels(form);
    }).observe(form, { attributes: true, attributeFilter: ['style', 'disabled'], subtree: true });
  }

  function scan() {
    var forms = document.querySelectorAll('pw-signup-form form, form#create_customer');
    Array.prototype.forEach.call(forms, patch);
    return forms.length > 0;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // The app renders its form asynchronously after this script runs; watch only until
  // it shows up, then stop (no need to keep observing the whole page afterwards).
  var bodyWatcher = new MutationObserver(function () {
    if (scan()) bodyWatcher.disconnect();
  });
  bodyWatcher.observe(document.body, { childList: true, subtree: true });
})();
